function toSnakeCase(inputString) {
	return inputString.split('').map((character) => {
		if (character == character.toUpperCase()) {
			return '_' + character.toLowerCase();
		} else {
			return character;
		}
	})
		.join('');
}

var get_wcurl = function( endpoint ) {
	return wc_add_to_cart_params.wc_ajax_url.toString().replace(
		'%%endpoint%%',
		endpoint
	);
};

const jQuery = window.jQuery;
let instance = null;
// jQuery.fn.serializeArrayAll = function () {
// 	var e = /\r?\n/g;
// 	return this.map(function () {
// 		return this.elements ? jQuery.makeArray(this.elements) : this;
// 	})
// 		.map(function (a, t) {
// 			var n = jQuery(this).val();
// 			return null == n
// 				? null == n
// 				: "checkbox" == this.type && 0 == this.checked
// 				? { name: this.name, value: this.checked ? this.value : "" }
// 				: jQuery.isArray(n)
// 				? jQuery.map(n, function (a, n) {
// 					  return { name: t.name, value: a.replace(e, "\r\n") };
// 				  })
// 				: { name: t.name, value: n.replace(e, "\r\n") };
// 		})
// 		.get();
// }

// jQuery(document).on("click", ".single_add_to_cart_button:not(.disabled)", function (a) {
// 	var t = jQuery(this),
// 		n = t.closest("form.cart"),
// 		r = n.find('input:not([name="product_id"]), select, button, textarea').serializeArrayAll() || 0;
// 	return (
// 		jQuery.each(r, function (e, a) {
// 			"add-to-cart" == a.name && ((a.name = "product_id"), (a.value = n.find("input[name=variation_id]").val() || t.val()));
// 		}),
// 		a.preventDefault(),
// 		jQuery(document.body).trigger("adding_to_cart", [t, r]),
// 		jQuery.ajax({
// 			type: "POST",
// 			url: woocommerce_params.wc_ajax_url.toString().replace("%%endpoint%%", "add_to_cart"),
// 			data: r,
// 			beforeSend: function (e) {
// 				t.removeClass("added").addClass("loading");
// 			},
// 			complete: function (e) {
// 				t.addClass("added").removeClass("loading");
// 			},
// 			success: function (a) {
// 				a.error & a.product_url ? (window.location = a.product_url) : jQuery(document.body).trigger("added_to_cart", [a.fragments, a.cart_hash, t]);
// 			},
// 		}),
// 		!1
// 	);
// });

/* global wc_add_to_cart_params */


/**
 * AddToCartHandler class.
 */
var AddToCartHandler = function () {
	
	if (typeof wc_add_to_cart_params === 'undefined') {
		console.log('erepas:AddToCartHandler: wc_add_to_cart_params is missing')
		return false;
	}

	this.requests = [];
	this.addRequest = this.addRequest.bind(this);
	this.run = this.run.bind(this);
	this.selected = null;
	instance = this;
	console.log('erepas: AddToCartHandler')
	jQuery(document.body)
		.on('click', '.add_to_cart_button, .single_add_to_cart_button, .button.product_type_variable', { addToCartHandler: this }, this.onAddToCart)
		.on('click', '.remove_from_cart_button', { addToCartHandler: this }, this.onRemoveFromCart)
		.on('change', '.qty', { addToCartHandler: this }, this.changeQty)
		.on('added_to_cart', this.updateButton)
		.on('removed_from_cart', { addToCartHandler: this }, this.updateFragments) //added_to_cart
		.on('show_variation', function ( event, variation ) {
			instance.selected = variation;
		});
};

/**
 * Add add to cart event.
 */
 AddToCartHandler.prototype.changeQty = function () {
	console.log('ChangeQty', this)
	let val = this.value ? this.value : 1;
	jQuery(this).closest('.loop-entry').find('.add_to_cart_button').attr('data-quantity', val);
};


/**
 * Add add to cart event.
 */
AddToCartHandler.prototype.addRequest = function (request) {
	this.requests.push(request);

	if (1 === this.requests.length) {
		this.run();
	}
};

/**
 * Run add to cart events.
 */
AddToCartHandler.prototype.run = function () {
	var requestManager = this,
		originalCallback = requestManager.requests[0].complete;

	requestManager.requests[0].complete = function () {
		if (typeof originalCallback === 'function') {
			originalCallback();
		}

		requestManager.requests.shift();

		if (requestManager.requests.length > 0) {
			requestManager.run();
		}
	};

	jQuery.ajax(this.requests[0]);
};

/**
 * Handle the add to cart event.
 */
AddToCartHandler.prototype.onAddToCart = function (e) {
	var $thisbutton = jQuery(this);
	var data = {};
	$thisbutton.removeClass('added');
	$thisbutton.addClass('loading-start').attr("disabled", true);
	e.preventDefault();

	console.log('erepas: onAddToCart', $thisbutton);
	
	if(!instance.selected && $thisbutton.hasClass('product_type_variable')) {
		alert('Veuillez sélectionner les options disponibles pour ce produit')
		return false;
	}

	// Fetch changes that are directly added by calling $thisbutton.data( key, value )
	jQuery.each($thisbutton.data(), function (key, value) {
		if (value && key !== "quantity") {
			data[key] = value;
		}
	});
	
	// Fetch data attributes in $thisbutton. Give preference to data-attributes because they can be directly modified by javascript
	// while `.data` are jquery specific memory stores.
	jQuery.each($thisbutton[0].dataset, function (key, value) {
		if (value) {
			data[key] = value;
		}
	});

	data = {
		...data,
		action: "xoo_wsc_add_to_cart"// "add_to_cart"
	};

	if(instance.selected) {
		if(instance.selected.variation_id) {
			data = {
				...data,
				variation_id: instance.selected.variation_id
			}
		}
		if(instance.selected.attributes) {
			data = {
				...data,
				variation: instance.selected.attributes
			}
		}
		if(instance.selected.attributes) {
			data = {
				...data,
				attributes: instance.selected.attributes
			}
		}
	}
	

	// if(!data['product_id']){
	// 	data['product_id'] = parseInt($thisbutton.val(), 10);
	// }
	data['add-to-cart'] = data['product_id'];
	delete data['product_id'];
	let productCard = $thisbutton.closest('.loop-entry.product');
	
	let inputData = productCard.find('input[type="hidden"], select');
	for (const input in inputData) {
		if (Object.hasOwnProperty.call(inputData, input)) {
			let el = inputData[input];
			data[el.name] = el.value;
		}
	}

	// // if(!data['quantity']){
	// data['quantity'] = $thisbutton.closest('.display-product form').first().find('input.qty').val();
	// // }

	// // $.each( $thisbutton.closest('.product-search-result').data(), function( key, value ) {
	// // 	data[ '_' + toSnakeCase(key) ] = value;
	// // });

	// let productCard = $thisbutton.closest('.loop-entry.product');

	// let weight_needed = jQuery('input[name="weight_needed"], select[name="weight_needed"]', productCard );
	// if (weight_needed.length) {
	// 	data['weight_needed'] = weight_needed.val();
	// }
	// if(!data['weight_needed']) {
	// 	data['weight_needed'] = 1;
	// }

	// let fixed_price = jQuery('input[name="_fixed_price"]', productCard);
	// if (fixed_price.length) {
	// 	data['_fixed_price'] = true;
	// }

	let measurement_needed_unit = jQuery('input.amount_needed', productCard);
	if (measurement_needed_unit.length) {
		data['_measurement_needed_unit'] = measurement_needed_unit.attr('data-unit');
	}

	if(data['_measurement_needed']) {
		data['weight_needed'] = data['_measurement_needed'];
	}

	// let conditioning_needed = jQuery('.woocommerce-Price-cunit', productCard);
	// if (conditioning_needed.length) {
	// 	data['_conditioning_needed'] = conditioning_needed.html();
	// }

	// if (data && !data['_measurement_needed']) {
	// 	data['_measurement_needed'] = '';
	// }
	// if (data && !data['_measurement_needed_unit']) {
	// 	data['_measurement_needed_unit'] = '';
	// }

	// if(data['weight_needed']){
	// 	data['weight_needed'] = parseFloat(data['weight_needed'], 10);
	// }
	// if(data['_measurement_needed']){
	// 	data['_measurement_needed'] = parseFloat(data['_measurement_needed'], 10);
	// }
	// if(data['_measurement_needed_unit']){
	// 	data['_measurement_needed_unit'] = parseFloat(data['_measurement_needed_unit'], 10);
	// }


	console.log('Posting:', data);

	// Trigger event.
	jQuery(document.body).trigger('adding_to_cart', [$thisbutton, data]);

	e.data.addToCartHandler.addRequest({
		type: 'POST',
		url: get_wcurl( 'xoo_wsc_add_to_cart' ),//wc_add_to_cart_params.ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'), //'add_to_cart' ),
		data,
		success: function (response) {

			if ( ! response )
				return;

			var this_page = window.location.toString();

			this_page = this_page.replace( 'add-to-cart', 'added-to-cart' );

			$thisbutton.removeClass('loading');

			if ( response.error && response.product_url ) {
				window.location = response.product_url;
				return;
			}

			fragments = response.fragments;
			cart_hash = response.cart_hash;

			// Block fragments class
			if ( fragments ) {
				jQuery.each(fragments, function(key, value) {
					jQuery(key).addClass('updating');
				});
			}

			// Block widgets and fragments
			jQuery('.shop_table.cart, .updating, .cart_totals,.widget_shopping_cart_top').fadeTo('400', '0.6').block({message: null, overlayCSS: {background: 'transparent url(' + woocommerce_params.ajax_loader_url + ') no-repeat center', backgroundSize: '16px 16px', opacity: 0.6 } } );
			
			// Changes button classes
			$thisbutton.addClass( 'added' );
			
			
			// View cart text
			if ( ! wc_add_to_cart_params.is_cart && $thisbutton.parent().find( '.added_to_cart' ).length === 0 ) {
				$thisbutton.after( ' <a href="' + wc_add_to_cart_params.cart_url + '" class="added_to_cart wc-forward" title="' + 
				wc_add_to_cart_params.i18n_view_cart + '">' + wc_add_to_cart_params.i18n_view_cart + '</a>' );
			}
			

			// Replace fragments
			if ( fragments ) {
				jQuery.each(fragments, function(key, value) {
					// console.log('Fragment', value)
					jQuery(key).replaceWith(value);
				});
			}

			// Unblock
			jQuery('.widget_shopping_cart, .updating, .widget_shopping_cart_top').stop(true).css('opacity', '1').unblock();

			// Cart page elements
			jQuery('.widget_shopping_cart_top').load( this_page + ' .widget_shopping_cart_top:eq(0) > *', function() {

				jQuery("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)").addClass('buttons_added').append('<input type="button" value="+" id="add1" class="plus" />').prepend('<input type="button" value="-" id="minus1" class="minus" />');

				jQuery('.widget_shopping_cart_top').stop(true).css('opacity', '1').unblock();

				jQuery('body').trigger('cart_page_refreshed');
			});
			
			// Cart page elements
			jQuery('.shop_table.cart').load( this_page + ' .shop_table.cart:eq(0) > *', function() {

				jQuery("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)").addClass('buttons_added').append('<input type="button" value="+" id="add1" class="plus" />').prepend('<input type="button" value="-" id="minus1" class="minus" />');

				jQuery('.shop_table.cart').stop(true).css('opacity', '1').unblock();

				jQuery('body').trigger('cart_page_refreshed');
			});				

			jQuery('.cart_totals').load( this_page + ' .cart_totals:eq(0) > *', function() {
				jQuery('.cart_totals').stop(true).css('opacity', '1').unblock();
			});
			// Trigger event so themes can refresh other areas
			jQuery('body').trigger( 'added_to_cart', [
				response.fragments,
				response.cart_hash,
				$thisbutton
			] );
			if (!response) {
				return;
			}

			// if (response.error && response.product_url) {
			// 	window.location = response.product_url;
			// 	return;
			// }

			// // Redirect to cart option
			// if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
			// 	window.location = wc_add_to_cart_params.cart_url;
			// 	return;
			// }

			// // Trigger event so themes can refresh other areas.
			// // jQuery(document.body).trigger('added_to_cart', [
			// // 	response.fragments,
			// // 	response.cart_hash,
			// // 	$thisbutton
			// // ]);
		},
		dataType: 'json'
	});

	return false;
	// }
};

/**
 * Update fragments after remove from cart event in mini-cart.
 */
AddToCartHandler.prototype.onRemoveFromCart = function (e) {
	var $thisbutton = jQuery(this),
		$row = $thisbutton.closest('.woocommerce-mini-cart-item');
	console.log('AddToCartHandler.onRemoveFromCart')

	e.preventDefault();

	$row.block({
		message: null,
		overlayCSS: {
			opacity: 0.6
		}
	});

	e.data.addToCartHandler.addRequest({
		type: 'POST',
		url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'remove_from_cart' ),
		data: {
			cart_item_key : $thisbutton.data( 'cart_item_key' )
		},
		success: function( response ) {
			if ( ! response || ! response.fragments ) {
				window.location = $thisbutton.attr( 'href' );
				return;
			}

			jQuery( document.body ).trigger( 'removed_from_cart', [ response.fragments, response.cart_hash, $thisbutton ] );
		},
		error: function() {
			window.location = $thisbutton.attr( 'href' );
			return;
		},
		dataType: 'json'
	});
};

/**
 * Update cart page elements after add to cart events.
 */
AddToCartHandler.prototype.updateButton = function (e, fragments, cart_hash, $button) {
	// $button = typeof $button === 'undefined' ? false : $button;
	// console.log('AddToCartHandler.updateButton');
	// e.preventDefault();
	// return false;
	console.log('Updating buttons')
	if ( $button ) {
		$button.removeClass( 'loading-start' ).removeAttr("disabled")
		$button.addClass( 'added' );

		// View cart text.
		if ( ! wc_add_to_cart_params.is_cart && $button.parent().find( '.added_to_cart' ).length === 0 ) {
			$button.after( ' <a href="' + wc_add_to_cart_params.cart_url + '" class="added_to_cart wc-forward" title="' +
				wc_add_to_cart_params.i18n_view_cart + '">' + wc_add_to_cart_params.i18n_view_cart + '</a>' );
		}

		jQuery( document.body ).trigger( 'wc_cart_button_updated', [ $button ] );
	} else {
		jQuery('.loading-start').removeClass( 'loading-start' ).removeAttr("disabled");
	}
};

/**
 * Update fragments after add to cart events.
 */
AddToCartHandler.prototype.updateFragments = function (e, fragments) {
	console.log('erepas: AddToCartHandler.updateFragments');
	if ( fragments ) {
		jQuery.each( fragments, function( key ) {
			jQuery( key )
				.addClass( 'updating' )
				.fadeTo( '400', '0.6' )
				.block({
					message: null,
					overlayCSS: {
						opacity: 0.6
					}
				});
		});

		jQuery.each( fragments, function( key, value ) {
			jQuery( key ).replaceWith( value );
			jQuery( key ).stop( true ).css( 'opacity', '1' ).unblock();
		});

		jQuery( document.body ).trigger( 'wc_fragments_loaded' );
	}
};

/**
 * Init AddToCartHandler.
 */



export const run = () => {
	console.log('erepas: add-to-cart.js')
	return new AddToCartHandler();
}